import axios from 'axios';
import { Config } from 'config';
import { getAccessToken } from 'lib/Helper/Auth';
import { CvCritiqueRequest, CvCritiqueResponse } from 'lib/Model/CvCritique';

export async function critiqueCv(
  requestData: CvCritiqueRequest,
): Promise<CvCritiqueResponse> {
  const formData = new FormData();
  formData.append('file', requestData.resume);

  const response = await axios.post(
    `${Config.API_BASE_URL}intranet/cv_critique`,
    formData,
    {
      headers: {
        'access-token': getAccessToken(),
      },
    },
  );

  return response.data as CvCritiqueResponse;
}
